<script type="ts">
	import { getRandomGuest } from '$Chat/helpers/profiles';

	export let channel: string;
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	const guest = getRandomGuest();

	let text: string;
	function strip(html: string) {
		let doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || '';
	}

	function onSubmit() {
		if (!strip(text)) {
			return;
		}

		const message = {
			author: guest,
			content: strip(text),
			time: new Date().toLocaleTimeString()
		};

		dispatch('insert', message);
		text = '';
	}

	function onPlus() {
		dispatch('plus');
	}
</script>

<form class="input-wrapper" on:submit|preventDefault={onSubmit}>
	<div class="plus-icon" on:click={onPlus}><span>+</span></div>
	<input bind:value={text} type="text" placeholder="Message #{channel}..." />
</form>

<style lang="scss">
	.input-wrapper {
		background-color: var(--demo-bg-40);
		border-radius: $border_radius;
		padding: 11px 0;

		grid-template-columns: 48px 1fr;

		display: grid;
		justify-items: center;
		align-items: center;
	}
	input {
		width: 100%;
		height: 100%;
		border: none;
		background: none;
		outline: none;
		font-size: 0.85rem;
		font-family: inherit;
		color: inherit;
		padding: 0;
		margin: 0;
		position: relative;
		top: -1px;

		&::placeholder {
			color: var(--demo-text-low);
		}
	}

	.plus-icon {
		width: 30px;
		height: 30px;
		background-color: var(--demo-bg-30);

		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;

		cursor: pointer;
		font-size: 20px;
		span {
			display: block;
			font-weight: 500;
			position: relative;
			top: -1px;
		}

		transition: all ease 200ms;
		&:hover {
			background-color: var(--demo-bg-20);
			background-color: var( --demo-accent );
		}
	}
</style>
